import { token } from '@atlaskit/tokens';

export const invalidStateStyle = {
	borderColor: token('color.border.danger'),
} as const;
